export interface QuickPriceAmounts {
  quantity: number;
  lineTotal: number;
  oldLineTotal: number;
  unitPrice: number;
  oldUnitPrice: number;
  onSale: boolean;
}

export function quickPriceAmounts(
  lineTotal: number,
  oldLineTotal: number,
  quantity: number,
): QuickPriceAmounts {
  const safeQuantity = Math.max(1, Math.round(Number(quantity) || 1));
  const safeLineTotal = Math.max(0, Number(lineTotal) || 0);
  const safeOldLineTotal = Math.max(safeLineTotal, Number(oldLineTotal) || safeLineTotal);
  const unitPrice = safeLineTotal / safeQuantity;
  const oldUnitPrice = safeOldLineTotal / safeQuantity;
  return {
    quantity: safeQuantity,
    lineTotal: safeLineTotal,
    oldLineTotal: safeOldLineTotal,
    unitPrice,
    oldUnitPrice,
    onSale: oldUnitPrice > unitPrice + 0.00001,
  };
}
